import {
  getCorporateRequiredProofStatusMessage,
  hasRequiredCorporateProofDocuments,
} from "../../../../utils/corporateOnboardingDocuments.js";

const CorporateRequiredProofStatus = ({ documents = [], t = (key) => key }) => {
  const complete = hasRequiredCorporateProofDocuments(documents);

  return (
    <p
      className={`text-sm mb-4 ${complete ? "text-emerald-600" : "text-amber-600"}`}
    >
      {getCorporateRequiredProofStatusMessage(t, documents)}
    </p>
  );
};

export default CorporateRequiredProofStatus;
